import React, {Component} from 'react';
import AdvancedLatexComponent from './AdvancedLatexComponent';

class SafeLatexViewComponent extends Component {
    constructor(props){
        super(props)


    }

    shouldComponentUpdate(nextProps, nextState){
        if(this.props.source != nextProps.source){
            return true
        }

        return false
    }

    render(){


        return(
           <AdvancedLatexComponent source = {this.props.source}/>
        )
    }
}

export default SafeLatexViewComponent